module.exports = __webpack_public_path__ + "static/img/vr.ae54e55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vr.jpg
// module id = kotc
// module chunks = 1